var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BgSection"},[(_vm.sectionId)?_c('span',{on:{"click":_vm.navigateToPage}},[_vm._v(_vm._s(_vm.sectionTitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }